import { useEffect } from "react";
import { useSelector } from "react-redux";
import Briciole from "../../shared/briciole/Briciole";
import CouponRow from "./couponRow/CouponRow";
import CopyToClipboard from "./CopyToClipboard";

const CouponsDetail = () => {
  const pageContent = useSelector((state) => state.currentPage.pageContent);
  const coupons = useSelector((state) => state.user.userData.coupons);
  const myAmbassadorCode = useSelector(
    (state) => state.user.userData.my_ambassador_code
  );
  const menuProfiloItems = useSelector(
    (state) => state.translations.menuLeftProfilo
  );
  const gestioneCouponsTranslation = useSelector(
    (state) => state.translations.coupons
  );
  const siteParams = useSelector((state) => state.siteParams);
  useEffect(() => {}, []);

  // controllo che esista la proprietà detail (altrimenti vuol dire che sto ancora recuperando i dati)
  if (!pageContent.detail) {
    return <div></div>;
  }

  const fascia_credito_ambassador = parseFloat(
    siteParams?.fascia_credito_ambassador
  );
  let virtualcouponsUnusedcreditNr = 0;

  function obscureString(str) {
    if (str.length <= 4) {
      return str;
    } else {
      const visibleChars = str.slice(-2);
      const obscuredChars = "*".repeat(str.length - 4);
      const visibleStart = str.slice(0, 2);
      return visibleStart + obscuredChars + visibleChars;
    }
  }
  const couponRows =
    coupons === null || coupons === undefined
      ? ""
      : Object.keys(coupons).map((couponIndex) => {
          const couponRow = coupons[couponIndex];
          if (couponRow.codiceCouponCredito === null) {
            virtualcouponsUnusedcreditNr++;
          }
          let str = couponRow.user.email;
          let dateParts = couponRow.created_at.substr(0, 10).split("-");
          let userInfo = obscureString(str);
          //$userEncriptedInfo = substr($userC->email, 0, 2) . '****' . substr($userC->email, -2);
          return (
            <CouponRow
              key={couponIndex}
              couponId={couponRow.id}
              couponIduserInfo={userInfo}
              couponDate={
                dateParts[2] + "/" + dateParts[1] + "/" + dateParts[0]
              }
            />
          );
        });

  let virtualcouponscreditNr = 0;
  if (coupons !== null && coupons !== undefined) {
    virtualcouponscreditNr = coupons.length;
  }

  const couponTable =
    virtualcouponscreditNr == 0 ? (
      myAmbassadorCode === null ? (
        <></>
      ) : (
        <div className="grid grid-cols-60 mt-0 sm:mt-3 xl:mt-6">
          <div className="col-span-60 flex flex-col justify-center px-8 xl:px-12 3xl:px-20 xl:pt-8 pb-6 sm:pb-8 xl:pb-12 3xl:py-14">
            <div className="text-ribola-congress-blue text-lg md:text-3xl font-opensansbold">
              <span
                className="leading-tight flex"
                dangerouslySetInnerHTML={{
                  __html: gestioneCouponsTranslation.nessuncoupon.itemName,
                }}
              ></span>
            </div>
          </div>
        </div>
      )
    ) : (
      <>
        <div className="grid grid-cols-60 mt-0 sm:mt-3 xl:mt-6">
          <div className="col-span-60 md:col-span-30 flex flex-col justify-center px-4 xl:px-6 3xl:px-10 xl:py-4 sm:py-4 3xl:py-7">
            <div className="h-full text-ribola-congress-blue text-lg md:text-3xl font-opensansbold bg-ribola-congress-blue-semitrasp px-4 py-6">
              <small className="text-center block">
                {gestioneCouponsTranslation.titoloelencocouponsleft.itemName}
              </small>
              <span className="text-center block">
                {gestioneCouponsTranslation.titoloelencocouponsstat.itemName
                  .replace(
                    "XXX",
                    virtualcouponscreditNr * fascia_credito_ambassador
                  )
                  .replace(
                    "YYY",
                    (virtualcouponscreditNr - virtualcouponsUnusedcreditNr) *
                      fascia_credito_ambassador
                  )}
              </span>
            </div>
          </div>
          <div className="col-span-60 md:col-span-30 flex flex-col justify-center px-4 xl:px-6 3xl:px-10 xl:py-4 sm:py-4 3xl:py-7">
            <div className="h-full text-ribola-congress-blue text-lg md:text-3xl font-opensansbold bg-ribola-congress-blue-semitrasp px-4 py-6">
              <small className="text-center block">
                {gestioneCouponsTranslation.titoloelencocouponsright.itemName}
              </small>
              <span className="text-center block">
                {gestioneCouponsTranslation.titoloelencocoupons.itemName.replace(
                  "XXX",
                  virtualcouponsUnusedcreditNr * fascia_credito_ambassador
                )}
              </span>
              <small className="text-center block">
                {gestioneCouponsTranslation.titoloelencocouponsright2.itemName}
              </small>
            </div>
          </div>
          <div className="col-span-60 flex flex-col justify-center px-8 xl:px-12 3xl:px-20 xl:pt-8 pb-6 sm:pb-8 xl:pb-12 3xl:py-14">
            <div className="text-ribola-congress-blue text-3xl md:text-4xl xl:text-5xl font-opensansbold">
              <small className="leading-tight flex">
                {gestioneCouponsTranslation.sottotitoloelencocoupons.itemName}
              </small>
            </div>
          </div>
        </div>
        <div className="px-8 xl:pl-12 3xl:pl-20">
          <div className="grid grid-cols-60 sm:gap-2 2xl:gap-4 font-opensansbold text-ribola-tundora border-b border-ribola-dove-gray text-sm 2xl:text-base pb-2">
            <div className="col-span-22 sm:col-span-12 md:col-span-10 flex items-center">
              <span>
                {gestioneCouponsTranslation.thDataOrdine.itemName.toUpperCase()}
              </span>
            </div>
            <div className="col-span-16 sm:col-span-12 md:col-span-10 flex items-center">
              <span>
                {gestioneCouponsTranslation.thUserEncripted.itemName.toUpperCase()}
              </span>
            </div>
          </div>
        </div>
        <div className="px-8 xl:pl-12 3xl:pl-20 text-sm 2xl:text-base">
          {couponRows}
        </div>
      </>
    );

  const couponMainPage =
    myAmbassadorCode === null ? (
      <div className="col-span-60 flex flex-col justify-center px-8 xl:px-12 3xl:px-20 xl:pt-8 pb-6 sm:pb-8 xl:pb-12 3xl:py-14">
        <h1 className="text-ribola-congress-blue text-3xl md:text-4xl xl:text-5xl font-opensansbold">
          <small className="leading-tight flex">
            {menuProfiloItems.couponsProfilo.itemName.toUpperCase()}
          </small>
        </h1>
        <div className="text-lg md:text-xl mt-3">
          <span
            className="leading-tight flex"
            dangerouslySetInnerHTML={{
              __html:
                gestioneCouponsTranslation.spiegazioneambassadorcode.itemName,
            }}
          ></span>
        </div>
      </div>
    ) : (
      <div className="col-span-60 flex flex-col justify-center px-8 xl:px-12 3xl:px-20 xl:pt-8 pb-6 sm:pb-8 xl:pb-12 3xl:py-14">
        <div className="grid grid-cols-60">
          <div className="col-span-60 md:col-span-60 flex flex-col justify-start">
            <h1 className="text-ribola-congress-blue text-3xl md:text-4xl xl:text-5xl font-opensansbold">
              <small className="leading-tight flex">
                {menuProfiloItems.couponsProfilo.itemName.toUpperCase()}
              </small>
            </h1>
            <h2 className="text-lg md:text-xl mt-3">
              <span className="leading-tight flex">
                {gestioneCouponsTranslation.sottotitoloambassadorcode.itemName}
              </span>
            </h2>
            <div className="text-ribola-congress-blue text-3xl md:text-4xl xl:text-5xl font-opensansbold mt-3">
              <span id="myAmbassadorCode" className="leading-tight flex">
                {myAmbassadorCode}
              </span>
            </div>

            <div className="text-lg md:text-xl mt-3">
              <span className="leading-tight flex">
                {gestioneCouponsTranslation.condividiambassadorcode.itemName}
              </span>
            </div>
            <div className="text-4xl md:text-4xl xl:text-5xl font-opensansbold flex items-center justify-start">
              <a
                href={`https://api.whatsapp.com/send?text=${gestioneCouponsTranslation.questoeilmioambassadorcode.itemName}%20${myAmbassadorCode}`}
                target="_blank"
                className="text-ribola-whatsapp-green px-4 py-1 mt-3"
              >
                <i className="fab fa-whatsapp text-4xl inline-block"></i>
              </a>

              <a
                href={`mailto:?body=${gestioneCouponsTranslation.questoeilmioambassadorcode.itemName}%20${myAmbassadorCode}&subject=${gestioneCouponsTranslation.questoeilmioambassadorcodesubjactmail.itemName}`}
                target="_blank"
                className="text-ribola-congress-blue px-4 py-1 mt-3"
              >
                <i className="far fa-envelope text-4xl inline-block"></i>
              </a>
              <CopyToClipboard text={myAmbassadorCode} />
            </div>
          </div>
          <div className="col-span-60 md:col-span-60 flex flex-col justify-start">
            <div className="text-lg md:text-xl mt-3">
              <span
                className="leading-tight flex"
                dangerouslySetInnerHTML={{
                  __html:
                    gestioneCouponsTranslation.spiegazioneambassadorcode
                      .itemName,
                }}
              ></span>
            </div>
          </div>
        </div>
      </div>
    );

  return (
    <div
      className={`col-start-1 lg:col-start-15 4xl:col-start-16 col-end-61 3xl:col-end-59 4xl:col-end-57 pb-6 sm:pb-12`}
    >
      <Briciole />
      <div className="grid grid-cols-60 mt-0 sm:mt-3 xl:mt-6">
        {couponMainPage}
      </div>
      {couponTable}
    </div>
  );
};

export default CouponsDetail;
